import Home from "@/components/routes/Home";
import WhyDigitalGuidelines from "@/components/routes/WhyDigitalGuidelines";
import HowToUse from "@/components/routes/HowToUse";
import Layout from "@/components/routes/Layout";
import Grid from "@/components/routes/Grid";
import Logo from "@/components/routes/Logo";
import Typography from "@/components/routes/Typography";
import Colors from "@/components/routes/Colors";
import Icons from "@/components/routes/Icons";
import Links from "@/components/routes/Links";
import Alerts from "@/components/routes/Alerts";
import Buttons from "@/components/routes/Buttons";
import Breadcrumbs from "@/components/routes/Breadcrumbs";
import Cards from "@/components/routes/Cards";
import Collapse from "@/components/routes/Collapse";
import Tabs from "@/components/routes/Tabs";
import Header from "@/components/routes/Header";
import Footer from "@/components/routes/Footer";
import Forms from "@/components/routes/Forms";
import Tables from "@/components/routes/Tables";
import Clearfix from "@/components/routes/Clearfix";
import Display from "@/components/routes/Display";
import Flex from "@/components/routes/Flex";
import Float from "@/components/routes/Float";
import Screenreaders from "@/components/routes/Screenreaders";
import Sizing from "@/components/routes/Sizing";
import Spacing from "@/components/routes/Spacing";
import Text from "@/components/routes/Text";
import Lists from "@/components/routes/Lists";
import PageTemplates from "@/components/routes/PageTemplates";
import Releases from "@/components/routes/Releases";
import Modal from "@/components/routes/Modal";
import Datepicker from "@/components/routes/Datepicker";
import Panel from "@/components/routes/Panel";
import Menu from "@/components/routes/Menu";
import Badges from "@/components/routes/Badges";
import MobileSubheader from "@/components/routes/MobileSubheader";
import Toggle from "@/components/routes/Toggle";
import Card from "@/components/routes/Card";
import Print from "@/components/routes/Print";
import Dialog from '@/components/routes/Dialog';

const routesObj = [
  {
    name: "Home",
    path: "/",
    component: Home,
    description: "Digital Guidelines is the State of Michigan design system and component library.",
    hideSideNav: true
  },
  {
    name: "Why Digital Guidelines?",
    path: "/why-digital-guidelines",
    component: WhyDigitalGuidelines,
    description: "Digital Guidelines is the State of Michigan design system and component library.",
    hideSideNav: true
  },
  {
    name: "How to Use",
    path: "/how-to-use",
    component: HowToUse,
    description: "How to get started with the State of Michigan's Digital Guidelines design system and component library",
    hideSideNav: true
  },
  {
    name: "Releases",
    path: "/releases",
    component: Releases,
    description: "Release notes for the State of Michigan's Digital Guidelines design system and component library",
    hideSideNav: true,
  },
  {
    name: "Overview",
    path: "/layout",
    description: "The State of Michigan's design system and component library overview of layouts, containers, and breakpoints",
    component: Layout
  },
  {
    name: "Grid",
    path: "/grid",
    description: "The State of Michigan's design system and component library grid system",
    component: Grid
  },
  {
    name: "Typography",
    path: "/typography",
    description: "The State of Michigan's design system and component library typography usage",
    component: Typography
  },
  {
    name: "Logo",
    path: "/logo",
    description: "The State of Michigan's design system and component library logo",
    component: Logo
  },
  {
    name: "Colors",
    path: "/colors",
    description: "The State of Michigan's design system and component library color choices",
    component: Colors
  },
  {
    name: "Icons",
    path: "/icons",
    description: "The State of Michigan's design system and component library icon set",
    component: Icons
  },
  {
    name: "Links",
    path: "/links",
    description: "The State of Michigan's design system and component library link component",
    component: Links
  },
  {
    name: "Alerts",
    path: "/alerts",
    description: "The State of Michigan's design system and component library alert component",
    component: Alerts
  },
  {
    name: "Buttons",
    path: "/buttons",
    description: "The State of Michigan's design system and component library button component",
    component: Buttons
  },
  {
    name: "Breadcrumbs",
    path: "/breadcrumbs",
    description: "The State of Michigan's design system and component library breadcrumb component",
    component: Breadcrumbs
  },
  {
    name: "Cards",
    path: "/cards",
    description: "The State of Michigan's design system and component library card component",
    component: Cards
  },
  {
    name: "Collapse",
    path: "/collapse",
    description: "The State of Michigan's design system and component library collapse or accordion component",
    component: Collapse
  },
  {
    name: "Tabs",
    path: "/tabs",
    description: "The State of Michigan's design system and component library tabs component",
    component: Tabs
  },
  {
    name: "Header",
    path: "/header",
    description: "The State of Michigan's design system and component library header component",
    component: Header
  },
  {
    name: "Footer",
    path: "/footer",
    description: "The State of Michigan's design system and component library footer component",
    component: Footer
  },
  {
    name: "Forms",
    path: "/forms",
    description: "The State of Michigan's design system and component forms, inputs, radio buttons, and checkboxes",
    component: Forms
  },
  {
    name: "Tables",
    path: "/tables",
    description: "The State of Michigan's design system and component library table component",
    component: Tables
  },
  {
    name: "Clearfix",
    path: "/clearfix",
    description: "The State of Michigan's design system and component library clearfix documentation",
    component: Clearfix
  },
  {
    name: "Display",
    path: "/display",
    description: "The State of Michigan's design system and component library display utilities",
    component: Display
  },
  {
    name: "Flex",
    path: "/flex",
    description: "The State of Michigan's design system and component library flexbox utilities",
    component: Flex
  },
  {
    name: "Float",
    path: "/float",
    description: "The State of Michigan's design system and component library float utilities",
    component: Float
  },
  {
    name: "Screenreaders",
    path: "/screenreaders",
    description: "The State of Michigan's design system and component library screenreader utilities",
    component: Screenreaders
  },
  {
    name: "Sizing",
    path: "/sizing",
    description: "The State of Michigan's design system and component library sizing utilities",
    component: Sizing
  },
  {
    name: "Spacing",
    path: "/spacing",
    description: "The State of Michigan's design system and component library spacing utilities",
    component: Spacing
  },
  {
    name: "Text",
    path: "/text",
    description: "The State of Michigan's design system and component library text utilities",
    component: Text
  },
  {
    name: "Lists",
    path: "/lists",
    description: "The State of Michigan's design system and component library list component",
    component: Lists
  },
  {
    name: "PageTemplates",
    path: "/page-templates",
    description: "The State of Michigan's design system and component library page templates",
    component: PageTemplates,
    hideSideNav: true
  },
  {
    name: "Modal",
    path: "/modal",
    description: "The State of Michigan's design system and component library modal component",
    component: Modal
  },
  {
    name: "Datepicker",
    path: "/datepicker",
    description: "The State of Michigan's design system and component library date picker component",
    component: Datepicker
  },
  {
    name: "Panel",
    path: "/panel",
    description: "The State of Michigan's design system and component library panel component",
    component: Panel
  },
  {
    name: "Menu",
    path: "/menu",
    description: "The State of Michigan's design system and component library menu component.  This can be used in conjunction with the header component.",
    component: Menu
  },
  {
    name: "Badges",
    path: "/badges",
    description: "The State of Michigan's design system and component library badge component",
    component: Badges
  },
  {
    name: "Mobile Subheader",
    path: "/mobilesubheader",
    description: "The State of Michigan's design system and component library mobile sub-header component.  This can be used in conjunction with the header component.",
    component: MobileSubheader
  },
  {
    name: "Toggle",
    path: "/toggle",
    description: "The State of Michigan's design system and component library toggle component.",
    component: Toggle
  },
  {
    name: "Card",
    path: "/card",
    description: "The State of Michigan's design system and component library card component.",
    component: Card
  },
  {
    name: "Print",
    path: "/print",
    description: "The State of Michigan's design system and component library print utilities.",
    component: Print
  },
  {
    name: 'Dialog',
    path: '/dialog',
    description: "The State of Michigan's design system and component library dialog component.",
    component: Dialog,
  },
];

const routes = routesObj.map((route) => {
  const extendedRoute = route;
  extendedRoute.meta = {
    title: `${route.name} | Digital Guidelines`,
    metaTags: [
      {
        description: `${route.description}`
      }
    ],
    hideSideNav: route.hideSideNav || false
  };
  return extendedRoute;
});

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js